import { ReactNode } from 'react';
import { ReceiptTextIcon, SearchIcon, TimerIcon } from '../Icons';
import { DashboardColumnStatus } from '@/shared';

type HourWidgetStyleResult = {
  icon: ReactNode;
  className: string;
};

export const hourWidgetStyling = (
  dashboardStatus: DashboardColumnStatus,
  estimatedSeconds?: number,
  usedSeconds: number = 0,
): HourWidgetStyleResult => {
  if (dashboardStatus == DashboardColumnStatus.Submitted || !estimatedSeconds) {
    return { className: '', icon: null };
  }

  if (dashboardStatus == DashboardColumnStatus.InEvaluation) {
    return { className: 'text-gray-400', icon: <SearchIcon /> };
  }

  if (dashboardStatus == DashboardColumnStatus.Concluded) {
    return { className: 'text-gray-400', icon: <ReceiptTextIcon /> };
  }

  const hoursUsedPercentage = estimatedSeconds
    ? (usedSeconds / estimatedSeconds) * 100
    : 0;

  if (hoursUsedPercentage <= 100) {
    return { className: 'text-blue-500', icon: <TimerIcon /> };
  }

  if (hoursUsedPercentage >= 116) {
    return { className: 'text-red', icon: <TimerIcon /> };
  }

  return { className: 'text-yellow', icon: <TimerIcon /> };
};
